import { BoxProps } from "@chakra-ui/react";
import React from "react";
import { HiExclamationCircle } from "react-icons/hi";

import { Alert } from "../../../../components";

type RedactionAlertProps = BoxProps & {
  description?: string;
};

const DEFAULT_DESC =
  "One or more responses from this interview were redacted and may have impacted the candidate's score. View interview for details.";

export const RedactionAlert: React.FC<RedactionAlertProps> = ({
  description = DEFAULT_DESC,
  ...boxProps
}) => {
  return (
    <Alert
      status="warning"
      description={description}
      showIcon
      canHide={false}
      mb={-2}
      borderRadius="6px"
      icon={HiExclamationCircle}
      {...boxProps}
    />
  );
};
